import React from 'react';
import { Typography } from '@material-ui/core';

interface Props {}

const Mit: React.FC<Props> = props => {
  return (
    <div className="Checkout">
      <div className="Confirmation">
        <div className="content">
          <Typography variant="h4">MIT demo page</Typography>
        </div>
      </div>
    </div>
  );
};

export default Mit;
